import {Component, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {FormBuilder, FormGroup} from "@angular/forms";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {SharedService} from "../../shared/shared.service";
import {CustomerOverviewService} from "./customer-overview.service";
import {DtoCustomerReport} from "./models/DtoCustomerReport";
import {SharedDataService} from "../../shared/shared-data.service";
import {DtoCustomerOverviewBaseItems} from "./models/DtoCustomerOverviewBaseItems";
import {DtoCustomersToCmExport} from "./models/DtoCustomersToCmExport";
import {ClipboardService} from "../../../fw/services/clipboard.service";
import {DialogService} from "@progress/kendo-angular-dialog";
import {CustomerReportsAddComponent} from "./dialogs/customer-reports-add.component";


@Component({
    selector: 'app-customer-overview',
    template: require('./customer-overview.component.html'),
    styles: [require('./customer-overview.component.css')]
})

@AutoUnsubscribe()
export class CustomerOverviewComponent implements OnInit {
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    emailKnownVisible: boolean;
    periodVisible: boolean;
    periodDisabled: boolean;
    salesgroupVisible: boolean;
    indexVisible: boolean;
    mailCodeVisible: boolean;
    employeeVisible: boolean;
    colPointsHidden: boolean;
    data: DtoCustomerReport[];
    filterHeaderConfig: PageHeaderBarConfig = {
        title: 'INSTELLINGEN',
        buttonDefinition: [
            {
                description: 'RESULTATEN',
                clickEventType: 'search',
                isSmall: false
            },
            {
                description: 'TOEVOEGEN',
                clickEventType: 'add',
                isSmall: false
            },
            {
                description: 'VERWIJDEREN',
                clickEventType: 'delete',
                isSmall: false
            },
            {
                description: 'ONTDUBBELEN',
                clickEventType: 'decouple',
                isSmall: false
            }
        ]
    };
    activeItems: Array<{ text: string, value: boolean }> = [
        {text: "Ja", value: true},
        {text: "Nee", value: false}
    ];
    genderItems: Array<{ text: string, value: number }> = [
        {text: "Man", value: 1},
        {text: "Vrouw", value: 2},
        {text: "Beide", value: 0}
    ];
    reportItems: Array<{ text: string, value: number }> = [
        {text: "Verjaardagen", value: 1},
        {text: "Emailadres", value: 2},
        {text: "Top klanten", value: 3},
        {text: "Verloren klanten", value: 4 },
        {text: "Nieuwe klanten", value: 5 },
        {text: "Bezoekfrequentie klanten", value: 6},
        {text: "Klanten op laatste bezoek", value: 7},
        {text: "Klanten per behandelomzetgroep", value: 8},
        {text: "Klanten per behandelnummer", value: 9},
        {text: "Klanten per artikelomzetgroep", value: 10},
        {text: "Klanten per artikelnummer", value: 11},
        {text: "Klanten op mailcode", value: 12},
        {text: "Klanten zonder verkoop", value: 13},
        {text: "Klanten laatst behandeld door", value: 14},
        {text: "Alle klanten", value: 15}
    ];
    periodItems: Array<{ text: string, value: number }> = [
        {text: "Deze week", value: 1},
        {text: "Deze maand", value: 2},
        {text: "Dit jaar", value: 3},
        {text: "Laatste 2 jaar", value: 4},
        {text: "Variabele periode", value: 5}
    ];
    baseItems: DtoCustomerOverviewBaseItems;
    excelFilename: string;
    filterForm: FormGroup = this.fb.group({
        reportKind: 1,
        userId: 0,
        genderId: 0,
        emailKnown: true,
        periodId: 1,
        from: null,
        untill: null,
        salesgroupId: 0,
        salessubgroupId: 0,
        index: 1,
        mailCode: null,
        employeeId: 0
    });
    pshbConfig: PageSubheaderBarConfig = {
        title: 'OVERZICHT',
        buttonDefinition: [
            {
                clickEventType: 'excel',
                description: 'EXCEL',
                isSmall: false
            }
        ]
    };

    columnDefinition: ColumnDefinition[] = [
        {
            key: 'customerNo',
            label: 'Klantnummer',
            type: 'number',
            width: '120px'
        },
        {
            key: 'name',
            label: 'Naam',
            type: 'string',
            width: '*'
        },
        {
            key: 'street',
            label: 'Straat',
            type: 'string',
            width: '*'
        },
        {
            key: 'zipcode',
            label: 'Postcode',
            type: 'string',
            width: '100px'
        },
        {
            key: 'city',
            label: 'Woonplaats',
            type: 'string',
            width: '200px'
        },
        {
            key: 'phoneNo',
            label: 'Telefoonnummer',
            type: 'string',
            width: '150px'
        },
        {
            key: 'email',
            label: 'Emailadres',
            type: 'string',
            width: '*'
        },
        {
            key: 'birthdate',
            label: 'Geb. datum',
            type: 'string',
            width: '130px',
            format: '{0:dd-MM-yyyy}'
        },
        {
            key: 'gender',
            label: 'M/V',
            type: 'string',
            width: '70px'
        },
        {
            key: 'useMailing',
            label: 'Mailen',
            type: 'boolean',
            width: '80px'
        },
        {
            key: 'visits',
            label: 'Bezoeken',
            type: 'number',
            width: '125px'
        },
        {
            key: 'lastVisitDateTime',
            label: 'Lts bezoek',
            type: 'string',
            width: '100px',
            format: '{0:dd-MM-yyyy}'
        },
        {
            key: 'spendAmount',
            label: 'Besteed',
            type: 'number',
            width: '120px'
        },
        {
            key: 'loyaltyPoints',
            label: 'Punten',
            type: 'number',
            width: '80px'
        },
        {
            key: 'origin',
            label: 'Herkomst',
            type: 'string',
            width: '150px'
        }
    ];

    constructor(private breadcrumService: BreadcrumService,
                public dialogService: DialogService,
                private fb: FormBuilder,
                private ss: SharedService,
                private clipboardService: ClipboardService,
                private sds: SharedDataService,
                private ds: CustomerOverviewService) {
    }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'klanten', isLastStep: false },
            { text: 'klant overzichten', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');

        this.filterForm.get('reportKind').valueChanges.subscribe(newVal => {
            this.setFilterForm(newVal);
            this.clearData();
        });

        this.filterForm.get('periodId').valueChanges.subscribe(newVal => {
            this.setFilterPeriod(newVal);
            this.clearData();
        });

        this.filterForm.get('userId').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.filterForm.get('genderId').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.filterForm.get('emailKnown').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.filterForm.get('from').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.filterForm.get('untill').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.filterForm.get('salesgroupId').valueChanges.subscribe(newVal => {
            this.clearData();
            this.filterForm.patchValue({ ['salessubgroupId']: 0 });
        });

        this.filterForm.get('salessubgroupId').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.filterForm.get('index').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.filterForm.get('mailCode').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.filterForm.get('employeeId').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        setTimeout(() => {
            this.setFilterForm(1);
            this.setFilterPeriod(1);
        });

        this.ds.getCustomerReportBaseItems().subscribe((res: DtoCustomerOverviewBaseItems) => {
            this.baseItems = res;
            if (res.useModCampagneManager) {
                this.pshbConfig.buttonDefinition.unshift({
                    clickEventType: 'exportcm',
                    description: 'EXPORTEER CM',
                    isSmall: false
                });
            }
            setTimeout(() => {
                this.loadData();
            });
        });
    }

    clearData() {
        this.grid.clearData();
        this.data = [];
    }

    loadData() {
        this.excelFilename = `Klant overzicht - ${this.reportItems.find(x => x.value == this.filterForm.get('reportKind').value).text}.xlsx`;
        this.ds.getCustomerReport({
            userId: this.filterForm.get('userId').value,
            emailKnown: this.filterForm.get('emailKnown').value,
            from: this.filterForm.get('from').value,
            genderId: this.filterForm.get('genderId').value,
            untill: this.filterForm.get('untill').value,
            reportKind: this.filterForm.get('reportKind').value,
            salesgroupId: this.filterForm.get('salesgroupId').value,
            salesSubgroupId: this.filterForm.get('salessubgroupId').value,
            index: this.filterForm.get('index').value,
            mailCode: this.filterForm.get('mailCode').value,
            employeeId: this.filterForm.get('employeeId').value
        }).subscribe((res: DtoCustomerReport[]) => {
            this.data = res;
            if (this.data.length > 0) {
                this.grid.showData(this.data);
            }
        });
    }

    setFilterForm(reportKind: number) {
        this.emailKnownVisible = reportKind == 2;
        this.periodVisible = (reportKind != 2 && reportKind != 13 && reportKind != 16 && reportKind != 12);
        this.salesgroupVisible = (reportKind == 8 || reportKind == 10);
        this.indexVisible = (reportKind == 9 || reportKind == 11);
        this.mailCodeVisible = reportKind == 12;
        this.employeeVisible = reportKind == 14;
        this.colPointsHidden = (reportKind != 15);

        if (reportKind == 8 && this.baseItems.treatmentSalesgroups.length > 0) {
            this.filterForm.patchValue({ ['salesgroupId']: this.baseItems.treatmentSalesgroups[0].id });
        }
        if (reportKind == 10 && this.baseItems.articleSalesgroups.length > 0) {
            this.filterForm.patchValue({ ['salesgroupId']: this.baseItems.articleSalesgroups[0].id });
        }

        this.filterForm.patchValue({ ['index']: 1 });
        this.filterForm.patchValue({ ['mailCode']: null });

        let hiddenColumns: string[] = [];
        if (reportKind != 15)
            hiddenColumns.push('loyaltyPoints');
        if (reportKind != 5)
            hiddenColumns.push('origin');
        if (reportKind != 1 && reportKind != 6 && reportKind != 7)
            hiddenColumns.push('visits');
        if (reportKind != 1 && reportKind != 3)
            hiddenColumns.push('spendAmount');
        this.grid.setHiddenColumns(hiddenColumns);

        if (reportKind == 1) {
            this.columnDefinition[10].label = 'Bezoeken lts jr';
            this.columnDefinition[12].label = 'Besteed lts jr';
        } else {
            this.columnDefinition[10].label = 'Bezoeken';
            this.columnDefinition[12].label = 'Besteed';
        }
    }

    setFilterPeriod(periodKind: number) {
        if (periodKind == 1) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfWeek(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.addDaysToDate(this.ss.getFirstDayOfWeek(this.ss.getCurrentDate()), 6) });
        } else if (periodKind == 2) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfMonth(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.getLastDayOfMonth(this.ss.getCurrentDate()) });
        } else if (periodKind == 3) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfYear(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.getLastDayOfYear(this.ss.getCurrentDate()) });
        } else if (periodKind == 4) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfYear(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.addYearsToDate(this.ss.getLastDayOfYear(this.ss.getCurrentDate()), 1) });
        } else if (periodKind == 5) {
            this.periodDisabled = false;
        }
    }

    phbBtnClicked(event) {
        if (event == 'search') {
            this.loadData();
        } else if (event == 'add') {
            this.addCustomer();
        } else if (event == 'delete') {
            this.deleteCustomers();
        } else if (event == 'decouple') {
            this.decoupleCustomers();
        }
    }

    pshbBtnClicked(event) {
        if (event == 'excel') {
            this.grid.saveAsExcel();
        } else if (event == 'exportcm') {
            this.exportToCM();
        }
    }

    getSalesgroups() {
        if (this.baseItems) {
            if (this.filterForm.get('reportKind').value == 8) {
                return this.baseItems.treatmentSalesgroups;
            } else if (this.filterForm.get('reportKind').value == 10) {
                return this.baseItems.articleSalesgroups;
            }
        }

        return null;
    }

    getSalessubgroups() {
        if (this.baseItems && this.filterForm.get('salesgroupId').value) {
            if (this.filterForm.get('reportKind').value == 8) {
                return this.baseItems.treatmentSalesgroups.find(x => x.id == this.filterForm.get('salesgroupId').value).treatmentSubSalesgroups;
            } else if (this.filterForm.get('reportKind').value == 10) {
                return this.baseItems.articleSalesgroups.find(x => x.id == this.filterForm.get('salesgroupId').value).articleSubSalesgroups;
            }
        }

        return null;
    }

    getEmployees() {
        if (this.baseItems) {
            if (this.filterForm.get('userId').value == 0) {
                return this.baseItems.employees.sort();
            } else {
                return this.baseItems.employees.filter(x => x.branchAvailabilities.some(x => x.userId == this.filterForm.get('userId').value)).sort();
            }
        }

        return null;
    }

    exportToCM() {
        this.ds
            .exportCustomersToCM(this.data.filter(x => x.useMailing))
            .subscribe((res: DtoCustomersToCmExport) => {
                this.ss
                    .confirm('Wilt u de campagne manager openen?')
                    .subscribe((doOpen: boolean) => {
                        if (doOpen)
                            this.clipboardService
                                .copy(res.clipboardFile)
                                .then(() => window.open(`http://www.retail-online.nl/campagne/login.asp?ID=${res.bnfDebitNumber}`));
                    });
            });
    }

    addCustomer() {
        const dialogRef = this.dialogService.open({
            content: CustomerReportsAddComponent
        });

        const dialogContent: CustomerReportsAddComponent =
            dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.chosenCustomer.subscribe((res: DtoCustomerReport) => {
            this.data.push(res);
            this.grid.showData(this.data);
        });
    }

    deleteCustomers() {
        if (this.grid.getMultipleSelectedIds()) {
            this.grid.getMultipleSelectedIds().forEach(id => {
                this.data.splice(this.data.findIndex(x => x.id == id), 1);
            });

            this.grid.showData(this.data);
        }
    }

    decoupleCustomers() {
        let custToRemove: Array<DtoCustomerReport> = [];
        let custToKeep: Array<DtoCustomerReport> = [];
        if (this.data) {
            this.data.forEach(customer => {
                custToKeep.push(customer);

                this.data
                    .filter(
                        x =>
                            x.id != customer.id &&
                            x.zipcode &&
                            customer.zipcode &&
                            x.zipcode.toLowerCase().replace(' ', '') ==
                            customer.zipcode.toLowerCase().replace(' ', '') &&
                            x.lastname &&
                            customer.lastname &&
                            x.lastname.toLowerCase().replace(' ', '') ==
                            customer.lastname.toLowerCase().replace(' ', '') &&
                            x.houseNumber &&
                            customer.houseNumber &&
                            x.houseNumber.toLowerCase().replace(' ', '') ==
                            customer.houseNumber.toLowerCase().replace(' ', '')
                    )
                    .forEach(tempCust => {
                        if (
                            !custToRemove.some(x => x.id == tempCust.id) &&
                            !custToKeep.some(x => x.id == tempCust.id)
                        )
                            custToRemove.push(tempCust);
                    });
            });

            custToRemove.forEach(customer => {
                this.data.splice(this.data.findIndex(x => x.id == customer.id), 1);
            });

            this.grid.showData(this.data);
        }

        this.ss.message('De klanten zijn ontdubbelt');
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/customers/customer-overview/customer-overview.component.ts